import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, Package, ShoppingBag, Archive, BarChart2, Users, Mail, LogOut } from 'lucide-react';
import { useAuthStore } from '../store/auth';
import styles from './AdminLayout.module.css';

const NAV = [
  { to: '/admin', icon: LayoutDashboard, label: 'admin.dashboard', end: true },
  { to: '/admin/products', icon: Package, label: 'admin.products' },
  { to: '/admin/orders', icon: ShoppingBag, label: 'admin.orders' },
  { to: '/admin/inventory', icon: Archive, label: 'admin.inventory' },
  { to: '/admin/analytics', icon: BarChart2, label: 'admin.analytics' },
  { to: '/admin/staff', icon: Users, label: 'admin.staff' },
  { to: '/admin/subscribers', icon: Mail, label: 'admin.subscribers' },
];

export default function AdminLayout() {
  const { t } = useTranslation();
  const { logout } = useAuthStore();
  const navigate = useNavigate();

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <div className={styles.sidebarHeader}>
          <span className={styles.logoText}>Sekar Silks</span>
          <span className={styles.adminBadge}>Admin</span>
        </div>
        <nav className={styles.nav}>
          {NAV.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
            >
              <Icon size={18} />
              <span>{t(label)}</span>
            </NavLink>
          ))}
        </nav>
        <button className={styles.logoutBtn} onClick={() => { logout(); navigate('/'); }}>
          <LogOut size={18} />
          <span>{t('nav.logout')}</span>
        </button>
      </aside>

      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
